module.exports = __webpack_public_path__ + "img/download.da89dc7a.svg";